import { render, staticRenderFns } from "./SettingEdit.vue?vue&type=template&id=7ff25958&scoped=true&"
import script from "./SettingEdit.vue?vue&type=script&lang=js&"
export * from "./SettingEdit.vue?vue&type=script&lang=js&"
import style0 from "./SettingEdit.vue?vue&type=style&index=0&id=7ff25958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff25958",
  null
  
)

export default component.exports